// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"7744a791f72ecc7066ca","655":"7bd7f8b396d50f26982d"}[chunkId] + ".js";
};